import classes from "./CompanyMode.module.scss";
import LoadingDots from "../UI/LoadingDots";
import { useState, useEffect, useContext } from "react";
import { DDD} from "../../lib/ddd/ddd";
import { useQuery } from '@tanstack/react-query'
import {  Col, Container, Row } from "react-bootstrap";
import Button from "../UI/Button";
import { NavLink } from "react-router-dom";
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import { OrgIdContext, ClientTypes, CustomerRelations } from "../../store/orgId_context";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { ReactComponent as CopyBtn } from "../../assets/copy.svg";
import CustomerRelationsComponent from "./customerRelations/CustomerRelationsComponent";
import { UserUIStateContext } from "../../store/userUIStateContext";
import { useTranslation } from 'react-i18next';

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const ddd = new DDD(apiRequestAddress);

const CompanyMode = () => {
    const [primaryDevice, setPrimaryDevice] = useState();
    const [primaryMode, setPrimaryMode] = useState();
    const [primaryLoading, setPrimaryLoading] = useState();
    const [primaryError, setPrimaryError] = useState();
    const [secondaryDevice, setSecondaryDevice] = useState();
    const [secondaryMode, setSecondaryMode] = useState();
    const [secondaryLoading, setSecondaryLoading] = useState();
    const [secondaryError, setSecondaryError] = useState();
    const [copied, setCopied] = useState();
    const [reset, setReset] = useState();
    const { t } = useTranslation();

    const { connectionKey,
        isIntegrator,
        connectionKeyMode,
        setConnectionKeyModeHandler,
        defaultDevice, 
        defaultDeviceMode, 
        setDefaultDeviceModeHandler,
        ISVCustomer, 
        clientType, AccCustomer, sessionInfo, customerRelation } = useContext(OrgIdContext);

    const {setClientWizardFinishedHandler} = useContext(UserUIStateContext);


    const onActiveClick = (id) =>{
        let params = {
            DeviceId: id,
            Mode : "PROD"
        }

        return ddd.Rpc_ExecuteExtension("EUeInvoices.ChangeMode", params)/*.then(res => {
            if(!res || res.result?.Status === "Error"){
                setError(res.result?.Reason || "An unknown error occured. Please contact administrator.")
            }else{
                setError(null);
                setIsActive(prev => !prev)
            }
        });*/
    }

    const onPrimaryActiveClick  = () =>{
        if(primaryLoading) return;
        setPrimaryLoading(true);
        setPrimaryError(null);

        onActiveClick(primaryDevice).then(res => {
            setPrimaryLoading(false);
            if(!res || res.result?.Status === "Error"){
                setPrimaryError(res.result?.Reason || t("An unknown error occured. Please contact administrator."));
            }else{
                setPrimaryError(null);
                primaryDevice === connectionKey ? setConnectionKeyModeHandler("PROD") : setDefaultDeviceModeHandler("PROD");
                setReset(Math.random());
            }
        });
    }

    const onSecondaryActiveClick = () =>{
        if(secondaryLoading) return;
        setSecondaryLoading(true);
        setSecondaryError(null);

        onActiveClick(secondaryDevice).then(res => {
            setSecondaryLoading(false);
            if(!res || res.result?.Status === "Error"){
                setSecondaryError(res.result?.Reason || t("An unknown error occured. Please contact administrator."))
            }else{
                setSecondaryError(null);
                secondaryDevice === connectionKey ? setConnectionKeyModeHandler("PROD") : setDefaultDeviceModeHandler("PROD");
                setReset(Math.random());
            }
        });
    }

    useEffect(() => {
        if(!primaryDevice) return;
        
        if(secondaryDevice){
            if(secondaryMode && primaryMode)
                setClientWizardFinishedHandler(true);
        }else if(primaryMode){
            setClientWizardFinishedHandler(true);
        }
    }, [primaryDevice, primaryMode, secondaryDevice, secondaryMode]);

    useEffect(()=> {
        if(clientType === ClientTypes.ISV){
            setPrimaryConnKey();
            //setSecondaryDefault();
        }else if(clientType === ClientTypes.AccService){
            if(!ISVCustomer && !isIntegrator){
                setPrimaryDefault();
            }else{
                setPrimaryDefault();
                setSecondaryConnKey();
            }
        }else if(clientType === ClientTypes.Company || clientType === ClientTypes.Enterprise){
            if(isIntegrator){
                setPrimaryDefault();
                setSecondaryConnKey();
            }else{
                setPrimaryDefault();
            }
        }else if(clientType === ClientTypes.EndClient){
            if(ISVCustomer){
                //TODO : some clients can have supportByDDD and have enabled invoice creation on this site. Where is this bool in db?
                if(customerRelation === CustomerRelations.EIOL){
                    setPrimaryConnKey();
                    setSecondaryDefault();
                }else{
                    setPrimaryConnKey();
                }
            }else if(AccCustomer){
                setPrimaryDefault();
            }else{
                if(isIntegrator){
                    setPrimaryDefault();
                    setSecondaryConnKey();
                }else{
                    setPrimaryDefault();
                }
            }
        }
    }, [connectionKey, ISVCustomer, clientType, AccCustomer, sessionInfo, reset]);

    

    const setPrimaryConnKey = () => {
        setPrimaryDevice(connectionKey);
        setPrimaryMode(connectionKeyMode === "PROD");
    }

    const setPrimaryDefault = () => {
        setPrimaryDevice(defaultDevice);
        setPrimaryMode(defaultDeviceMode === "PROD");
    }

    const setSecondaryDefault = () => {
        setSecondaryDevice(defaultDevice);
        setSecondaryMode(defaultDeviceMode === "PROD");
    }

    const setSecondaryConnKey = () => {
        setSecondaryDevice(connectionKey);
        setSecondaryMode(connectionKeyMode === "PROD");
    }

    const onCpyConnKeyClick = () => {
        navigator.clipboard.writeText(connectionKey);

        setCopied(connectionKey);
        setTimeout(() => {
            setCopied(false);
        }, 1500);
    }
    /*useEffect(() => {
        if(!isTransformerPending){
            setIsActive(transformerData.result?.Result?.device?.Mode === "PROD");
        }
    }, [isTransformerPending, transformerData])*/

    return (
        <>
        <div className={`${classes["container"]} `}>
            <div className={`d-flex`}>
                <div className="p-3">
                    <ForwardToInboxIcon style={{width:"5rem", height:"5rem"}}/>
                    <span className={classes["issue"]}><h4><strong>ISSUE</strong></h4></span>
                </div>
                <div className="justify-content-center my-auto p-3" style={{flex:"1"}}>
                    <span>
                        {primaryDevice !== connectionKey && <>
                            {t(`By enabling this option, you will allow your company to send real invoices into the production environment of the Tax Authority
                            and to other chosen e-paths to reach your buyer.`)}
                        </>}
                        {primaryDevice === connectionKey && <>
                            {t(`By enabling this option, you will allow your company to send, via this connection key, real invoices into the production environment
                            of the Tax Authority and to other chosen e-paths to reach your buyer.`)}
                        </>}
                    </span>
                    {primaryDevice === connectionKey && <div className={classes["connIdText"]} style={{marginTop:"2rem"}} onClick={onCpyConnKeyClick}>
                        {connectionKey}<CopyBtn className="ps-2"/>{copied && <span>Copied!</span>}
                    </div>}
                </div>
                <div className="p-3 justify-content-center my-auto">
                    {primaryMode && <CheckCircleIcon style={{width:"3rem", height:"3rem", color:"green"}}/>}
                    {!primaryMode && <UnpublishedIcon style={{width:"3rem", height:"3rem", color:"#005683"}}/>}
                </div>
            </div>
            {primaryError && <Row className={classes["errorAlert"]}>
                <Col className="col-1"><ErrorOutlineIcon style={{width:"2rem", height:"2rem", color:"red"}} /></Col>
                <Col>{primaryError}</Col>
            </Row>}
            {!primaryMode && <div style={{textAlign:"right", padding:"1rem"}}>
                {!primaryLoading &&<Button onClick={onPrimaryActiveClick}>
                    {t(`Activate`)}
                </Button>}
                {primaryLoading && <>
                    <LoadingDots/>
                </>}
            </div>}
        </div>
        {secondaryDevice && <>
            <div className={`${classes["container"]} mt-3`}>
                <div className={`d-flex`}>
                    <div className="p-3">
                        <ForwardToInboxIcon style={{width:"5rem", height:"5rem"}}/>
                        <span className={classes["issue"]}><h4><strong>ISSUE</strong></h4></span>
                    </div>
                    <div className="justify-content-center my-auto p-3" style={{flex:"1"}}>
                        {secondaryDevice !== connectionKey && <>
                            {t(`By enabling this option, you will allow your company to send real invoices into the production environment of the Tax Authority
                            and to other chosen e-paths to reach your buyer.`)}
                        </>}
                        {secondaryDevice === connectionKey && <>
                            {t(`By enabling this option, you will allow your company to send, via this connection key, real invoices into the production environment
                            of the Tax Authority and to other chosen e-paths to reach your buyer.`)}
                        </>}
                        {secondaryDevice === connectionKey && <div className={classes["connIdText"]} style={{marginTop:"2rem"}} onClick={onCpyConnKeyClick}>
                            {connectionKey}<CopyBtn className="ps-2"/>{copied && <span>{t(`Copied!`)}</span>}
                        </div>}
                    </div>
                    <div className="p-3 justify-content-center my-auto">
                        {secondaryMode && <CheckCircleIcon style={{width:"3rem", height:"3rem", color:"green"}}/>}
                        {!secondaryMode && <UnpublishedIcon style={{width:"3rem", height:"3rem", color:"#005683"}}/>}
                    </div>
                </div>
                {secondaryError && <Row className={classes["errorAlert"]}>
                    <Col className="col-1"><ErrorOutlineIcon style={{width:"2rem", height:"2rem", color:"red"}} /></Col>
                    <Col>{secondaryError}</Col>
                </Row>}
                {!secondaryMode && <div style={{textAlign:"right", padding:"1rem"}}>
                    {!secondaryLoading &&<Button onClick={onSecondaryActiveClick}>
                        {t(`Activate`)}
                    </Button>}
                    {secondaryLoading && <>
                        <LoadingDots/>
                    </>}
                </div>}
            </div> 
        </>}
        {/* <Container className={`${classes["container"]} d-flex flex-column`}>
            <Row>
                <Col className="col-2">
                    <Row className="justify-content-center">
                        <ForwardToInboxIcon style={{width:"5rem", height:"5rem"}}/>
                    </Row>
                    <Row className="justify-content-center">
                        <span className={classes["issue"]}><h4><strong>ISSUE</strong></h4></span>
                    </Row>
                </Col>
                <Col className="my-auto"><span>By enabling this option, you will allow your company to send real invoices into the production environment of the Tax Authority and to other chosen e-paths to reach your buyer.</span></Col>
                <Col className="col-1">
                    {isActive && <CheckCircleIcon style={{width:"3rem", height:"3rem", color:"green"}}/>}
                    {!isActive && <UnpublishedIcon style={{width:"3rem", height:"3rem", color:"#005683"}}/>}
                </Col>
            </Row>
            {error && 
            <Row className={classes["errorAlert"]}>
                <Col className="col-1"><ErrorOutlineIcon style={{width:"2rem", height:"2rem", color:"red"}} /></Col>
                <Col>{error}</Col>
            </Row>
            }
            
            <Row className="mt-auto" style={{textAlign:"right", padding:"1rem"}}>
                <Col>
                {!isActiveLoading && 
                    <Button onClick={onActiveClick}>
                        {isActive && <>De-activate</>}
                        {!isActive && <>Activate</>}
                    </Button>
                }
                {isActiveLoading && 
                <LoadingDots/>
                }
                </Col>
            </Row>
        </Container> */}
        </>
    )
}

export default CompanyMode;